import { VFC } from 'react'
import { UserIcon } from 'src/components/Image/UserIcon'
import { RequestBoxCompany } from 'src/models/RequestBox'
import { Counter } from 'src/models/Room'
import { fontWeightBold } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import styled from 'styled-components'
import { MESSAGE_DATE_FORMAT } from '../Message/common'
import {
  ContentContainer,
  MessageBottom,
  MessageDiv,
  Timestamp,
} from '../Message/styles'
import { RequestBoxContent } from './RequestBoxContent'

const CounterRequestBoxComponent: VFC<{
  sender: Counter
  requestBox: RequestBoxCompany
  showProfile: (userId: number) => void
}> = ({ requestBox, sender, showProfile }) => {
  const { id, iconSrc, companyName } = sender || {}
  const onClick = id ? () => showProfile(id) : undefined
  return (
    <MessageDiv>
      <UserIconDiv>
        <UserIcon src={iconSrc} size="40px" onClick={onClick} />
      </UserIconDiv>
      <div>
        <CompanyName onClick={onClick}>{companyName}</CompanyName>
        <ContentContainer>
          <RequestBoxContent requestBox={requestBox} />
        </ContentContainer>
      </div>
      {requestBox.requestAt && (
        <MessageBottom>
          <Timestamp>
            {requestBox.requestAt.format(MESSAGE_DATE_FORMAT)}
          </Timestamp>
        </MessageBottom>
      )}
    </MessageDiv>
  )
}

export const CounterRequestBox = styled(CounterRequestBoxComponent)``

const CompanyName = styled.h4<{ onClick?: () => void }>`
  font-size: 14px;
  font-weight: ${fontWeightBold};
  margin-bottom: 8px;
  ${({ onClick }) => onClick && 'cursor: pointer;'}
`
const UserIconDiv = styled.div`
  ${flexCenter}
`
